(function ($, Drupal, drupalSettings, once) {

  'use strict';

  Drupal.behaviors.analyticsBikeTennessee = {

    attach: function (context, settings) {
      $(once('biketn_analytics_functions', 'body', context)).each(function () {
        // Homepage - Explore Biking Events - button
        $(once('analytics', '.landing-page--bike-tn--consumer .bike-tn--topography-background.green .button')).click(function (e) {
          var asset = $(this).attr('href');
          Drupal.behaviors.analyticsBikeTennessee.pushToDataLayer('bike tn- home', 'explore biking events', asset);
        });

        // Homepage - Need More Inspiration - links
        $(once('analytics', '.landing-page--bike-tn--consumer .paragraph-item--biketennessee-articles a')).click(function (e) {
          var asset = $(this).attr('href');
          Drupal.behaviors.analyticsBikeTennessee.pushToDataLayer('bike tn- home', 'articles', asset);
        });

        // Route Page - View on ridewithgps.com - button
        $(once('analytics', '.page-node-type-biketn-route .route--overview .button')).click(function (e) {
          var asset = $(this).attr('href');
          Drupal.behaviors.analyticsBikeTennessee.pushToDataLayer('bike tn- routes', 'view on ridewithgps.com', asset);
        });

        // Route Page - View on ridewithgps.com - button
        $(once('analytics', '.page-node-type-biketn-route .route--ride-gps-embed .button')).click(function (e) {
          var asset = $(this).attr('href');
          Drupal.behaviors.analyticsBikeTennessee.pushToDataLayer('bike tn- routes', 'view on ridewithgps.com', asset);
        });

        // Route Page - See More - link
        $(once('analytics', '.page-node-type-biketn-route .route--about--link')).click(function (e) {
          var asset = $(this).attr('href');
          Drupal.behaviors.analyticsBikeTennessee.pushToDataLayer('bike tn- routes', 'about this route- see more', asset);
        });

        // Route Page - Nearby Attractions (Eat & Drink) - links
        $(once('analytics', '.page-node-type-biketn-route .route--nearby-attractions .eat a.node')).click(function (e) {
          var asset = $(this).attr('href');
          Drupal.behaviors.analyticsBikeTennessee.pushToDataLayer('bike tn- routes', 'eat & drink', asset);
        });

        // Route Page - Nearby Attractions (Places to Stay) - links
        $(once('analytics', '.page-node-type-biketn-route .route--nearby-attractions .stay a.node')).click(function (e) {
          var asset = $(this).attr('href');
          Drupal.behaviors.analyticsBikeTennessee.pushToDataLayer('bike tn- routes', 'places to stay', asset);
        });

        // Route Page - Nearby Attractions (Things to Do) - links
        $(once('analytics', '.page-node-type-biketn-route .route--nearby-attractions .do a.node')).click(function (e) {
          var asset = $(this).attr('href');
          Drupal.behaviors.analyticsBikeTennessee.pushToDataLayer('bike tn- routes', 'things to do', asset);
        });

        // Route Page - Articles - links
        $(once('analytics', '.page-node-type-biketn-route .route--articles a')).click(function (e) {
          var asset = $(this).attr('href');
          Drupal.behaviors.analyticsBikeTennessee.pushToDataLayer('bike tn- routes', 'articles', asset);
        });

        // Route Page - Nearby Routes - links
        $(once('analytics', '.page-node-type-biketn-route .route--nearby-routes .teaser-card')).click(function (e) {
          var asset = $(this).attr('href');
          Drupal.behaviors.analyticsBikeTennessee.pushToDataLayer('bike tn- routes', 'explore nearby routes', asset);
        });

        // Route Page - Nearby Routes - Explore More Routes
        $(once('analytics', '.page-node-type-biketn-route .route--nearby-routes .button-wrap a')).click(function (e) {
          Drupal.behaviors.analyticsBikeTennessee.pushToDataLayer('bike tn- routes', 'explore nearby routes', 'explore more routes');
        });

        // About Page - Bicycle Laws - link
        $(once('analytics', '.path-biketennessee-about .biketn--about-laws a')).click(function (e) {
          var asset = $(this).attr('href');
          Drupal.behaviors.analyticsBikeTennessee.pushToDataLayer('bike tn- about', 'tn bike laws', asset);
        });

        // Universal - Header Navigation - links
        $(once('analytics', '.menu--biketn-main-navigation .menu-item a')).click(function (e) {
          var asset = $(this).text();
          Drupal.behaviors.analyticsBikeTennessee.pushToDataLayer('bike tn- universal', 'navigation', asset);
        });

        // Universal - Header - Logo
        $(once('analytics', '#block-biketn-sitebranding a')).click(function (e) {
          Drupal.behaviors.analyticsBikeTennessee.pushToDataLayer('bike tn- universal', 'navigation', 'header logo');
        });

        // Universal - Footer - Privacy Policy
        $(once('analytics', 'footer .menu--biketn-footer-utilities a')).click(function (e) {
          Drupal.behaviors.analyticsBikeTennessee.pushToDataLayer('bike tn- universal', 'footer', 'privacy policy');
        });

        // Universal - Footer - Logo
        $(once('analytics', 'footer .block-biketn-biketnfooterlogo a')).click(function (e) {
          Drupal.behaviors.analyticsBikeTennessee.pushToDataLayer('bike tn- universal', 'footer', 'footer logo');
        });

        // Universal - Footer - Main Navigation
        $(once('analytics', 'footer .menu--biketn-footer-navigation a')).click(function (e) {
          var asset = $(this).text();
          Drupal.behaviors.analyticsBikeTennessee.pushToDataLayer('bike tn- universal', 'footer', asset);
        });

        // Universal - Footer - Contact Link
        $(once('analytics', 'footer .block-biketn-biketnfootercontact a')).click(function (e) {
          var asset = $(this).text();
          Drupal.behaviors.analyticsBikeTennessee.pushToDataLayer('bike tn- universal', 'footer', asset);
        });

        // Universal - Footer - TN Sounds Perfect Logo
        $(once('analytics', 'footer .block-biketn-biketnfooteraffiliates .logo-item:first-child a')).click(function (e) {
          Drupal.behaviors.analyticsBikeTennessee.pushToDataLayer('bike tn- universal', 'footer', 'tn sounds perfect');
        });

        // Universal - Footer - TN State Parks Logo
        $(once('analytics', 'footer .block-biketn-biketnfooteraffiliates .logo-item:not(:first-child) a')).click(function (e) {
          Drupal.behaviors.analyticsBikeTennessee.pushToDataLayer('bike tn- universal', 'footer', 'tn state parks');
        });
      });
    },

    /**
     * Push Analytics event to DataLayer.
     *
     * @param {string} eventCategory
     *   The eventAction - usually page-level indicator.
     * @param {string} eventAction
     *   The eventAction - usually the button text.
     * @param {string} eventLabel
     *   The eventLabel - usually the url.
     * @param {string} eventvalue
     *   The eventvalue - usually a blank string.
     * @param {string} event
     *   The event - usually 'eventClick'.
     */
    pushToDataLayer: function (eventCategory, eventAction, eventLabel, eventvalue = '', event = 'eventClick') {
      dataLayer.push({
        eventCategory: eventCategory,
        eventAction: eventAction,
        eventLabel: eventLabel,
        eventvalue: eventvalue,
        event: event
      });
    }
  };
})(jQuery, Drupal, drupalSettings, once); // eslint-disable-line no-undef
